const SHOW_AVAILABILITY = 'SHOW_AVAILABILITY';
const HIDE_AVAILABILITY = 'HIDE_AVAILABILITY';

const initialState = { open: false };

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SHOW_AVAILABILITY:
      return { open: true };
    case HIDE_AVAILABILITY:
      return { open: false };
    default:
      return { ...state };
  }
}

export function showAvailability() {
  return dispatch => dispatch({ type: SHOW_AVAILABILITY });
}

export function hideAvailability() {
  return dispatch => dispatch({ type: HIDE_AVAILABILITY });
}
